import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LANGS = ["fr", "en", "de", "ru", "es", "vi", "th"];

// /r/pseudo opens the landing page in the SPONSOR's language
// (falls back to browser auto-detection if the sponsor is unknown).
export const RefRedirect = () => {
  const { username } = useParams();
  const clean = (username || "").trim().toLowerCase();
  const [target, setTarget] = useState(null);

  useEffect(() => {
    if (clean) {
      try {
        localStorage.setItem("prenet-ref", clean);
      } catch {}
    }
    let alive = true;
    (async () => {
      let to = `/?ref=${encodeURIComponent(clean)}`;
      try {
        const res = await fetch(`${API}/registrations/${clean}`);
        if (res.ok) {
          const d = await res.json();
          if (LANGS.includes(d.lang)) to = `/${d.lang}?ref=${encodeURIComponent(clean)}`;
        }
      } catch {}
      if (alive) setTarget(to);
    })();
    return () => {
      alive = false;
    };
  }, [clean]);

  if (!target) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-night" data-testid="ref-redirect-loading">
        <span className="h-6 w-6 animate-spin rounded-full border-2 border-signal/30 border-t-signal" />
      </div>
    );
  }
  return <Navigate to={target} replace />;
};

export default RefRedirect;